export default function BurgerIcon() {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 9.33301H28" stroke="#145DA0" strokeWidth="2" strokeLinecap="round" />
            <path d="M4 16H28" stroke="#145DA0" strokeWidth="2" strokeLinecap="round" />
            <path d="M4 22.667H28" stroke="#145DA0" strokeWidth="2" strokeLinecap="round" />
        </svg>
    );
}
